import { Link, Navigate, useLocation, useParams } from 'react-router-dom';
import StudentTopicProgressPanel from '../components/StudentTopicProgressPanel';
import { useAuth } from '../context/AuthContext';
import { useTabIdentity } from '../hooks/useTabIdentity';

/**
 * Прогресс по темам (отдельная страница).
 * Ученик: /topic-progress.
 * Родитель: /parent/children/:studentId/topic-progress (только чтение; обычно редирект в кабинет).
 * Учительский URL /teacher/students/:id/topic-progress редиректится на карточку с ?tab=topics.
 */
export default function StudentTopicProgressPage() {
  const { studentId: routeStudentId } = useParams();
  const location = useLocation();
  const { user, loading: authLoading } = useAuth();

  const isTeacherCabinetRoute = Boolean(routeStudentId) && location.pathname.startsWith('/teacher/');
  const isParentRoute = Boolean(routeStudentId) && location.pathname.startsWith('/parent/');
  const targetStudentId = (isTeacherCabinetRoute || isParentRoute)
    ? Number(routeStudentId)
    : user?.id;

  useTabIdentity(
    (isTeacherCabinetRoute || isParentRoute) && routeStudentId
      ? {
          title: 'Темы',
          badge: 'Т',
          colorKey: `student:${routeStudentId}`,
        }
      : null,
  );

  if (isTeacherCabinetRoute && routeStudentId) {
    return <Navigate to={`/teacher/students/${routeStudentId}?tab=topics`} replace />;
  }

  if (!authLoading && !user) {
    return <Navigate to="/login" replace />;
  }

  if (!isParentRoute && user && !user.is_student) {
    return <Navigate to="/" replace />;
  }

  if (authLoading || !user || !targetStudentId) {
    return (
      <div className="loading-screen">
        <div className="spinner" />
        <p>Загрузка...</p>
      </div>
    );
  }

  const pageTitle = isParentRoute ? 'План занятий' : 'Мой прогресс по темам';

  return (
    <div className="student-topic-progress-page">
      <div className="page-header">
        <h1>{pageTitle}</h1>
        <p className="page-subtitle">
          {isParentRoute
            ? 'Актуальный план работы и заметки преподавателей. Редактировать может только автор заметки.'
            : 'Заметки преподавателей о вашем прогрессе по темам. Редактировать может только автор заметки.'}
        </p>
        {isParentRoute ? (
          <p className="page-subtitle">
            <Link to="/parent" className="back-link">
              ← Кабинет родителя
            </Link>
            {' · '}
            <Link to={`/parent/children/${routeStudentId}/activity`}>Журнал попыток</Link>
          </p>
        ) : (
          <p className="page-subtitle">
            <Link to="/my-teachers" className="back-link">
              ← Мои преподаватели
            </Link>
          </p>
        )}
      </div>

      <StudentTopicProgressPanel
        studentId={targetStudentId}
        canEdit={false}
        showJournal={!isParentRoute}
      />
    </div>
  );
}
